export function FontsService ({socket}) {

    const events = new andy.EventManager();

    const dataset = new andy.Dataset('andy.fonts'); 

    return  {
        dataset,
        on: events.addEventListener
    }
}